// for popup when adding to cart
document.addEventListener("DOMContentLoaded", function domLoaded() {
  if (!window.Shopify) return;

  const oldOnItemAdded = Shopify.onItemAdded;

  Shopify.onItemAdded = function onItemAddedHandle(line_item) {
    if (typeof oldOnItemAdded === 'function') {
      try { oldOnItemAdded(line_item); } catch (e) { console.error('Error in generic onItemAdded'); }
    }

    try {
      const modal  = document.getElementById('modalAddToCartProduct');
      const descEl = modal?.querySelector('.description');
      if (!descEl) return;

      const props = line_item.properties || {};
      let extraHtml = '';

      if (String(props['Player name']  || '').trim()) extraHtml += `<div>Ime: ${props['Player name']}</div>`;
      if (String(props['Player number']|| '').trim()) extraHtml += `<div>Broj: ${props['Player number']}</div>`;

      if (extraHtml) {
        descEl.querySelector('.player-info')?.remove();
        const wrapper = document.createElement('div');
        wrapper.className = 'player-info';
        wrapper.innerHTML = extraHtml;
        descEl.appendChild(wrapper);
      }
    } catch (e) {
      console.error('Error showing player info!');
    }
  };
});

// ─── State ────────────────────────────────────────────────────────────────────
let customEnabled = false;
let customLogo    = false;

// ─── Helpers ─────────────────────────────────────────────────────────────────
const checkIfMobile = () => window.innerWidth < 576;

// Registry keys double as the canvas font-family names — jersey-registry.liquid
// registers each FontFace under its key. No fallback to a real family name here:
// a missing registry should look wrong, not quietly render today's font.
function jerseyFont(role) {
  const key = window.JERSEY_FONTS_IN_USE?.[role];
  if (!key) {
    console.warn(`[jersey] no ${role} font registered — falling back to sans-serif`);
    return 'sans-serif';
  }
  return `"${key}"`;
}

// Reads one jersey_style field. Returns null for blank/absent/unparseable — blank is
// meaningful (see "No hidden defaults" in docs/jersey-customization-plan.md), so callers
// decide what a null means for their field rather than getting a number handed to them.
function styleNum(field) {
  const style = window.JERSEY_STYLE;
  if (!style) return null;
  const raw = style[field];
  if (raw === null || raw === undefined || raw === '') return null;
  const n = typeof raw === 'number' ? raw : parseFloat(raw);
  return Number.isFinite(n) ? n : null;
}

// Resolves a style field naming a number image into its asset url. Returns '' when the
// field is blank, and warns on a key the registry does not know — same contract as the
// font keys: dropdown for convenience, registry as the authority.
function styleImage(field) {
  const style = window.JERSEY_STYLE;
  const key   = style && style[field];
  if (!key) return '';
  const url = window.JERSEY_ASSETS?.numberImages?.[key];
  if (!url) {
    warnOnce('image:' + key,
      field + ' "' + key + '" is not in the registry — add it to jersey-registry.liquid, or fix the preset choice list in the admin');
    return '';
  }
  return url;
}

// Not a default table. These are used only when a required field is missing, and they
// are deliberately plain and wrong-looking: one size for everything, dead centre, no
// arch, no spacing. A default would mask misconfiguration by looking plausible; this is
// meant to be seen. Every product goes draft → customize → review → active, so whoever
// is editing has to notice.
const JERSEY_ERROR_STATE = { scale: 0.12, x: 0.5, y: 0.5 };

const jerseyWarned = new Set();
function warnOnce(key, message) {
  if (jerseyWarned.has(key)) return;
  jerseyWarned.add(key);
  console.warn('[jersey] ' + message);
}

function getLuminance(hex) {
  hex = hex.replace('#', '');
  return 0.299 * parseInt(hex.slice(0, 2), 16)
       + 0.587 * parseInt(hex.slice(2, 4), 16)
       + 0.114 * parseInt(hex.slice(4, 6), 16);
}

function applyOverlay(overlayId, hasContent) {
  const overlay = document.getElementById(overlayId);
  if (overlay) overlay.style.display = hasContent ? 'block' : 'none';
}

function hideZoomButton() {
  const zoomButton = document.querySelector('.mediaimageholder .tt-btn-zomm');
  if (!zoomButton) return;
  const hide = customEnabled || customLogo;
  zoomButton.style.opacity       = hide ? '0' : '';
  zoomButton.style.pointerEvents = hide ? 'none' : '';
}

let currentSlide = null;

function updateActiveItem(fromWhere = '', fromPlayer = false) {
  if (customEnabled) {
    const p         = window.currentPersonalizationData;
    const hasName   = !!(p.resolvedName);
    const hasNumber = !!(p.resolvedNumber);

    const targetSlide = (fromPlayer || hasName) ? 1 : (hasNumber ? 0 : null);

    // fromPlayer always navigates (mobile has no gallery observer to track currentSlide)
    // otherwise skip if already on the correct slide
    if (targetSlide !== null && (fromPlayer || targetSlide !== currentSlide)) {
      currentSlide = targetSlide;
      const smallGallery = document.getElementById('smallGallery');
      const imageThumbs  = smallGallery?.querySelectorAll('a[data-item-type=image]');
      if (imageThumbs?.length > targetSlide) {
        setTimeout(() => imageThumbs[targetSlide].click(), 150);
      }
      setTimeout(() => updateMobileSlider(customEnabled, targetSlide), 150);
    }
  }

  setTimeout(() => {
    const hide = customEnabled || customLogo;
    document.querySelectorAll('.zoomContainer').forEach(zc => {
      zc.style.display = hide ? 'none' : '';
    });
  }, 500);
}

function updateMobileSlider(enabled, goToSlide = null) {
  const mobileSlider = document.getElementById('mobile-product-slider-main');
  if (!mobileSlider || !window.jQuery || !jQuery(mobileSlider).hasClass('slick-initialized')) return;

  if (enabled && goToSlide !== null) {
    jQuery(mobileSlider).slick('slickGoTo', goToSlide);
    // Mirror desktop observer behaviour — show front overlay when landing on slide 0
    if (goToSlide === 0) drawFrontCanvases();
  }

  const slides = mobileSlider.querySelectorAll('.slick-track .slick-slide');

  const frontOverlay = document.querySelector('#jersey-overlay-front-mobile');
  const backOverlay  = document.querySelector('#jersey-overlay-mobile');

  if (frontOverlay && slides[0]) slides[0].appendChild(frontOverlay);
  if (backOverlay  && slides[1]) slides[1].appendChild(backOverlay);
}

// ─── Shared state ─────────────────────────────────────────────────────────────
// Personalization (name/number/color) — written by updateJerseyUI
window.currentPersonalizationData = { resolvedName: '', resolvedNumber: '', color: '' };

// Last back-canvas draw args, kept so redrawJersey() can repaint without a reload.
// Tuning a style value by eye is the fastest way to find a number, and every value the
// canvas reads is looked up at draw time, so editing window.JERSEY_STYLE and repainting
// is enough — nothing is cached.
window.currentJerseyDraw = null;

// Logo (src) — written by updateJerseyLogoUI ONLY when logo variants exist
// Starts empty; front canvas just won't show logo if product has no logo variants
// Offsets are not here: they live on the jersey_style metaobject and initJerseyCanvas
// reads them straight from window.JERSEY_STYLE.
window.currentLogoState = { src: '', firstBg: '' };

// ─── Shared front-canvas draw (called by both update* functions) ──────────────
const FRONT_LOGO_OPTS = { xPct: 0.6, yPct: 0.22, widthPct: 0.06, angle: 0 };

function drawFrontCanvases(skipOverlay = false) {
  const p  = window.currentPersonalizationData;
  const ls = window.currentLogoState;

  // Show overlay if there's a number to display OR a logo to display
  const showOverlay = !!(p.resolvedNumber) || !!(ls.src);

  if (skipOverlay) {
    // Explicitly hide front overlay so theme doesn't keep slider on slide 0
    applyOverlay('jersey-overlay-front',        false);
    applyOverlay('jersey-overlay-front-mobile', false);
  } else {
    applyOverlay('jersey-overlay-front',        showOverlay);
    applyOverlay('jersey-overlay-front-mobile', showOverlay);
  }

  if (!showOverlay) return;

  paintFrontCanvases();
}

// Paint only — no overlay visibility, so this never moves the slider. Showing the front
// overlay makes the theme jump to slide 0, which is correct when the shopper picks a
// number but wrong for a plain repaint of what is already on screen.
function paintFrontCanvases() {
  const p  = window.currentPersonalizationData;
  const ls = window.currentLogoState;

  // Desktop front canvas — number always shown if set; logo only if src is set
  initJerseyCanvas({
    id:          'jessey-canvas-front',
    number:      p.resolvedNumber,
    color:       p.color,
    bg:          ls.firstBg,
    logo:        ls.src,
    logoOptions: FRONT_LOGO_OPTS,
  });

  // Mobile front canvas
  initJerseyCanvas({
    id:          'jessey-canvas-front-mobile',
    number:      p.resolvedNumber,
    color:       p.color,
    bg:          ls.firstBg,
    logo:        ls.src,
    logoOptions: FRONT_LOGO_OPTS,
  });
}

// ─── Main jersey UI functions ─────────────────────────────────────────────────

/**
 * Called from jersey-personalization.liquid via Alpine x-effect.
 * Responsible for: back canvas (name + number) + keeping front canvas number in sync.
 * Does NOT call updateJerseyLogoUI — logo state is managed independently.
 */
window.updateJerseyUI = function updateJerseyUIHandle(options) {
  customEnabled = options.enabled;

  const resolvedName   = options.resolvedName   || '';
  const resolvedNumber = options.resolvedNumber || '';
  const color          = options.color          || '';
  const secondBg       = options.secondBackground || '';
  const firstBg        = options.firstBackground  || '';
  const fromPlayer     = options.fromPlayer            || false;

  // Update shared personalization state
  window.currentPersonalizationData = { resolvedName, resolvedNumber, color };
  // Always keep firstBg fresh so drawFrontCanvases can use it even if logo liquid never ran
  window.currentLogoState.firstBg = firstBg;

  const hasContent = customEnabled && (resolvedName || resolvedNumber);
  applyOverlay('jersey-overlay',        hasContent);
  applyOverlay('jersey-overlay-mobile', hasContent);

  hideZoomButton()

  // Back canvas — name + number + torches
  window.currentJerseyDraw = { name: resolvedName, number: resolvedNumber, color, bg: secondBg };
  initJerseyCanvas({ id: 'jessey-canvas',        ...window.currentJerseyDraw });
  initJerseyCanvas({ id: 'jessey-canvas-mobile', ...window.currentJerseyDraw });

  if (checkIfMobile()) updateMobileSlider(true);

  // Hide front overlay only when we're navigating away from slide 0 (back slide will be shown)
  // If user is already on slide 0, keep front overlay visible so number shows
  const skipFrontOverlay = (fromPlayer || !!resolvedName) && currentSlide !== 0;
  drawFrontCanvases(skipFrontOverlay);

  updateActiveItem('updateJerseyUI', fromPlayer);
};

/**
 * Called from jersey-custom-logo.liquid via Alpine x-effect.
 * Only rendered when both logo_without AND logo_with variants exist.
 * Responsible for: logo state + front canvas logo.
 * Does NOT call updateJerseyUI.
 */
window.updateJerseyLogoUI = function updateJerseyLogoUIHandle(options) {
  customLogo = options.enabled || false;

  const src      = options.src      || '';
  const firstBg  = options.firstBackground || '';
  // Update shared logo state — clear src when disabled so logo doesn't render
  window.currentLogoState = { src: customLogo ? src : '', firstBg };

  updateActiveItem('updateJerseyLogoUI');
  hideZoomButton();

  if (checkIfMobile()) updateMobileSlider(customLogo, 0);

  // Front canvas — number from personalization state + logo from logo state
  drawFrontCanvases();
};

// ─── Canvas rendering ─────────────────────────────────────────────────────────
/**
 * @param {object} opts
 * @param {string}  opts.id            - canvas element id
 * @param {string}  [opts.name]        - player name (back canvas)
 * @param {string}  [opts.number]      - player number
 * @param {string}  [opts.color]       - text color hex
 * @param {string}  [opts.bg]          - background image (url or CSS selector)
 * @param {string}  [opts.logo]        - logo image url
 * @param {object}  [opts.logoOptions] - logo position/size config
 * The number image (the emblem inside the digits) is not passed in either — the style
 * names a registry key per variant and initJerseyCanvas resolves it below.
 *
 * Offsets are not passed in — they live on the jersey_style metaobject and are read from
 * window.JERSEY_STYLE below, picking the back or front pair from the canvas id. They are
 * fractions of canvas size, X of width and Y of height, not pixels: the canvas is sized
 * from the product image on desktop and from the slider width on mobile, so a pixel
 * offset means something different at each breakpoint. A fraction does not.
 */
function initJerseyCanvas(opts) {
  const {
    id          = '',
    name        = '',
    number      = '',
    color       = '',
    bg          = '',
    logo        = '',
    logoOptions = {},
  } = opts;

  const canvas = document.getElementById(id);
  if (!canvas) return;

  canvas.classList.add('active-canvas');
  const ctx = canvas.getContext('2d');

  const defaultLogoOpts = { xPct: 0.5, yPct: 0.28, widthPct: 0.18, angle: 0, anchor: 'center' };
  const logoOpts = Object.assign({}, defaultLogoOpts, logoOptions);

  const isFront = id.includes('front');

  // Blank offset = 0, an honest neutral: the element sits where the style puts it.
  const offsetX     = styleNum(isFront ? 'jersey_front_offset_x' : 'jersey_back_offset_x') ?? 0;
  const offsetY     = styleNum(isFront ? 'jersey_front_offset_y' : 'jersey_back_offset_y') ?? 0;
  const logoOffsetX = styleNum('logo_offset_x') ?? 0;
  const logoOffsetY = styleNum('logo_offset_y') ?? 0;

  // Emblem inside the digits. The two fields hold the light and dark *artwork*; which one
  // is used depends on the text colour, because the emblem has to contrast with the digit
  // it sits inside, not with the jersey. Both blank = no emblem. One set = that one is
  // used whatever the colour, skipping the switch.
  const numberImageLight = styleImage('back_number_image_light');
  const numberImageDark  = styleImage('back_number_image_dark');

  // Offset helpers. canvas.width/height are only set once draw() has the base image, and
  // these are only ever called from inside draw(), so reading them here is safe.
  const shiftX = v => v + canvas.width  * offsetX;
  const shiftY = v => v + canvas.height * offsetY;

  // ── Image loader ──────────────────────────────────────────────────────────
  function loadImage(srcOrSelector) {
    return new Promise(resolve => {
      if (!srcOrSelector) return resolve(null);
      let src = srcOrSelector;
      if (/^[.#]/.test(src) || src.startsWith('img')) {
        const el = document.querySelector(src);
        src = el?.src || el?.getAttribute('data-src') || el?.getAttribute('src') || '';
        if (!src) return resolve(null);
      }
      const img = new Image();
      img.onload  = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = src;
    });
  }

  // ── Digit layout helper ───────────────────────────────────────────────────
  function getDigitLayout(ctx, text, xCenter, letterSpacing) {
    const digits = text.toString().split('');
    const widths = digits.map(d => ctx.measureText(d).width);
    const total  = widths.reduce((a, b) => a + b, 0) + letterSpacing * (digits.length - 1);
    let x = xCenter - total / 2;
    const centers = widths.map(w => { const cx = x + w / 2; x += w + letterSpacing; return cx; });
    return { digits, widths, centers, totalWidth: total };
  }

  function drawCenteredNumber(ctx, text, xCenter, yCenter, letterSpacing = 0) {
    const layout = getDigitLayout(ctx, text, xCenter, letterSpacing);
    layout.centers.forEach((cx, i) => ctx.fillText(layout.digits[i], cx, yCenter));
  }

  // ── Torch icons over digits ───────────────────────────────────────────────
  // Everything here is em of the number's *real* rendered font size, and the emblem is
  // placed against the digit's own centre — so one set of values serves 1- and 2-digit
  // numbers alike. The old code sized off canvas.height * 0.29, which was never the digit
  // font size; the 0.85 shrink and -0.05 lift were hand-matched compensation for that and
  // fall out now that the real fontPx is read.
  function drawTorches(ctx, canvas, number, color, torchWhiteImg, torchBlackImg, letterSpacing, fontPx, xCenter, yCenter) {
    const layout      = getDigitLayout(ctx, number, xCenter, letterSpacing);
    const torchImg    = getLuminance(color) > 150 ? torchBlackImg : torchWhiteImg;

    // Blank scale = emblem as tall as the digits; blank offset = centred on the digit.
    const torchHeight = fontPx * (styleNum('back_number_image_scale') ?? 1);
    const emblemDy    = fontPx * (styleNum('back_number_image_offset_y') ?? 0);
    const torchWidth  = torchHeight * (torchImg.naturalWidth / torchImg.naturalHeight);
    // yCenter already carries the product's offset — this is only the emblem's own drop
    // below the digit's centre, in em of the digit font size.
    const emblemY     = yCenter + emblemDy;

    // Per-digit X nudges — a property of the face, so they live in the registry beside
    // the font file, keyed by the number font in use. Unlisted digits are 0.
    const numberKey = window.JERSEY_FONTS_IN_USE?.number;
    const nudges    = window.JERSEY_ASSETS?.fonts?.[numberKey]?.nudges || {};

    layout.digits.forEach((d, i) => {
      const nudgeX = (nudges[d] || 0) * fontPx;
      ctx.drawImage(
        torchImg,
        layout.centers[i] - torchWidth / 2 + nudgeX,
        emblemY - torchHeight / 2,
        torchWidth,
        torchHeight
      );
    });
  }

  // ── Main draw ─────────────────────────────────────────────────────────────
  async function draw() {
    const [baseImg, logoImg, torchWhiteImg, torchBlackImg] = await Promise.all([
      loadImage(bg), loadImage(logo), loadImage(numberImageLight), loadImage(numberImageDark),
    ]);
    if (!baseImg) return;

    const mobileSilder = document.querySelector('#mobile-product-slider-main');
    if (window.innerWidth <= 575 && mobileSilder) {
      canvas.width = canvas.height = mobileSilder.offsetWidth;
    } else {
      canvas.width  = baseImg.naturalWidth  || baseImg.width;
      canvas.height = baseImg.naturalHeight || baseImg.height;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(baseImg, 0, 0, canvas.width, canvas.height);

    // Logo
    if (logoImg) {
      const w  = Math.round(canvas.width  * (logoOpts.widthPct || 0.18));
      const h  = Math.round(w * logoImg.naturalHeight / logoImg.naturalWidth);
      const lx = Math.round(canvas.width  * ((logoOpts.xPct || 0.5)  + logoOffsetX));
      const ly = Math.round(canvas.height * ((logoOpts.yPct || 0.28) + logoOffsetY));
      ctx.save();
      ctx.translate(lx, ly);
      if (logoOpts.angle) ctx.rotate(logoOpts.angle * Math.PI / 180);
      ctx.drawImage(logoImg, logoOpts.anchor === 'left' ? 0 : -w / 2, logoOpts.anchor === 'top' ? 0 : -h / 2, w, h);
      ctx.restore();
    }

    // Name (arched)
    if (name) {
      ctx.save();
      ctx.fillStyle  = color || '#efedee';
      const MAX_LETTERS    = 15;
      // name_scale and name_baseline_y have no neutral: 0 renders nothing, or renders at
      // the canvas's top edge. Missing either drops this element to the error state.
      const nameScale      = styleNum('name_scale');
      const nameBaselineY  = styleNum('name_baseline_y');
      const nameErrored    = nameScale === null || nameBaselineY === null;
      if (nameErrored) {
        warnOnce('name', 'name_scale or name_baseline_y is not set — drawing the name in the error state');
      }
      const baselineY      = nameErrored ? JERSEY_ERROR_STATE.y : nameBaselineY;
      const BASE_FONT      = Math.round(canvas.height * (nameErrored ? JERSEY_ERROR_STATE.scale : nameScale));
      const MIN_FONT       = 8;
      const MAX_WIDTH      = canvas.width * 0.3;
      const REDUCTION      = 0.1;
      const letters        = name.toUpperCase();
      const numLetters     = Math.min(letters.length, MAX_LETTERS);

      let fontPx = BASE_FONT - (BASE_FONT - MIN_FONT) * (numLetters - 1) / (MAX_LETTERS - 1) * REDUCTION;
      fontPx = Math.max(MIN_FONT, fontPx);

      const nameFont = jerseyFont('name');
      ctx.font = `${fontPx}px ${nameFont}`;
      let textWidth = ctx.measureText(letters).width;
      while (textWidth > MAX_WIDTH && fontPx > MIN_FONT) {
        fontPx -= 1;
        ctx.font  = `${fontPx}px ${nameFont}`;
        textWidth = ctx.measureText(letters).width;
      }

      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';
      const cx            = shiftX(canvas.width / 2);
      const cy            = shiftY(canvas.height * baselineY);
      // Blank radius = straight baseline. It is a divisor below, so a blank reaching the
      // arithmetic would make totalAngle NaN and draw nothing at all — the silent failure
      // the error state exists to prevent.
      const archRadius    = nameErrored ? null : styleNum('name_arch_radius');
      const rotateFactor  = nameErrored ? 0 : (styleNum('name_letter_tilt') ?? 0);
      const letterSpacing = nameErrored ? 0 : (styleNum('name_letter_spacing') ?? 0) * fontPx;

      const widths = [...letters].map(ch => ctx.measureText(ch).width + letterSpacing);
      const totalW = widths.reduce((a, b) => a + b, 0);

      if (archRadius === null) {
        let x = cx - totalW / 2;
        for (let i = 0; i < letters.length; i++) {
          ctx.fillText(letters[i], x + widths[i] / 2, cy);
          x += widths[i];
        }
      } else {
        const radius     = canvas.height * archRadius;
        const totalAngle = totalW / radius;
        const startAngle = -totalAngle / 2;
        let cum = 0;
        for (let i = 0; i < letters.length; i++) {
          const angle = startAngle + (cum + widths[i] / 2) / radius;
          ctx.save();
          ctx.translate(cx + radius * Math.sin(angle), cy - radius * Math.cos(angle));
          ctx.rotate(angle * rotateFactor);
          ctx.fillText(letters[i], 0, 0);
          ctx.restore();
          cum += widths[i];
        }
      }
      ctx.restore();
    }

    // Number
    if (number) {
      const numStr      = number.toString();
      const MIN_FONT    = 20;
      const isDouble    = numStr.length > 1;
      const REDUCTION   = 0.15;

      // Scale and Y have no neutral blank; missing either drops the number to the error
      // state. The stored Y is the *single-digit* position — shrinking a 2-digit number by
      // REDUCTION moves its optical centre, and the delta below compensates for that
      // shrink, so it belongs with the autofit machinery rather than in the config.
      const DOUBLE_DIGIT_DY = isFront ? 0.009 : -0.003;
      const numberScale = styleNum(isFront ? 'front_number_scale' : 'back_number_scale');
      const numberYBase = styleNum(isFront ? 'front_number_y' : 'back_number_y');
      // front_number_x has no neutral either — blank would mean the left edge, not centre.
      const numberXBase = isFront ? styleNum('front_number_x') : 0.5;
      const numErrored  = numberScale === null || numberYBase === null || numberXBase === null;
      if (numErrored) {
        warnOnce(isFront ? 'front_number' : 'back_number',
          (isFront ? 'front number scale, Y or X' : 'back number scale or Y') + ' is not set — drawing the number in the error state');
      }

      const BASE_FONT = Math.round(canvas.height * (numErrored ? JERSEY_ERROR_STATE.scale : numberScale));
      let fontPx = isDouble
        ? BASE_FONT - (BASE_FONT - MIN_FONT) * REDUCTION
        : BASE_FONT;
      fontPx = Math.max(MIN_FONT, fontPx);

      const numberY = numErrored
        ? shiftY(canvas.height * JERSEY_ERROR_STATE.y)
        : shiftY(canvas.height * (numberYBase + (isDouble ? DOUBLE_DIGIT_DY : 0)));

      ctx.font         = `${fontPx}px ${jerseyFont('number')}`;
      ctx.fillStyle    = color || '#efedee';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';

      // em of the number's own font size, so one value covers both breakpoints.
      const letterSpacing = numErrored
        ? 0
        : (styleNum(isFront ? 'front_number_spacing' : 'back_number_spacing') ?? 0) * fontPx;

      // The back number is centred; the front sits slightly off-centre on the chest.
      const numberX = shiftX(canvas.width * (numErrored ? JERSEY_ERROR_STATE.x : numberXBase));

      // textBaseline 'middle' is engine-defined: WebKit derives it from the font's
      // ascent/descent, Blink from the em box. On Brittney at 151px those land 37px apart
      // — the same glyphs (both engines report an identical 357.8px ink box), just a
      // different origin. That moved the number between browsers while the emblem, placed
      // arithmetically from numberY, stayed put.
      //
      // Measuring the ink cancels it. Drawing at numberY - inkCenterOffset puts the ink's
      // centre on numberY whatever the engine means by 'middle', so numberY becomes a real
      // visual centre and back_number_y means one thing everywhere. The emblem then keys
      // off that same point below.
      const numberMetrics = ctx.measureText(number);
      const rawInkCentre  = (numberMetrics.actualBoundingBoxDescent - numberMetrics.actualBoundingBoxAscent) / 2;
      // Pre-2021 Safari omits the actualBoundingBox* metrics; 0 leaves the old behaviour.
      const inkCentreOffset = Number.isFinite(rawInkCentre) ? rawInkCentre : 0;

      drawCenteredNumber(ctx, number, numberX, numberY - inkCentreOffset, letterSpacing);

      // Back canvas only — a front-number emblem is deliberately out of scope, and both
      // call sites already take the same arguments if that changes.
      const emblemImg = isFront ? null : (torchWhiteImg || torchBlackImg);
      if (emblemImg) {
        // numberY, not the shifted draw position: the digits were drawn offset so their
        // ink centres on numberY, so numberY is where the number visually is. drawTorches
        // must never recompute x or y, or the emblem drifts off the number as soon as
        // front_number_x is configurable.
        drawTorches(ctx, canvas, number, color, torchWhiteImg || emblemImg, torchBlackImg || emblemImg, letterSpacing, fontPx, numberX, numberY);
      }
    }
  }

  draw();
}

/**
 * Repaint every canvas from the current state. Meant for tuning from the console:
 *
 *   JERSEY_STYLE.name_arch_radius = 0.6; redrawJersey()
 *
 * Style values are read at draw time, so no reload is needed. Repaints only: overlay
 * visibility is left alone, so the gallery stays on whichever image you are looking at —
 * tuning a back-jersey value must not throw you to the front one.
 *
 * Two things it cannot do: a font key change needs that face registered first
 * (jersey-registry loads only the fonts the style named at page load), and edits here are
 * not saved — the metaobject is still the source of truth, so write the number you settle
 * on into the admin.
 */
window.redrawJersey = function redrawJersey() {
  jerseyWarned.clear();
  if (window.currentJerseyDraw) {
    initJerseyCanvas({ id: 'jessey-canvas',        ...window.currentJerseyDraw });
    initJerseyCanvas({ id: 'jessey-canvas-mobile', ...window.currentJerseyDraw });
  } else {
    console.warn('[jersey] nothing drawn yet — enable personalization and set a name or number first');
  }
  paintFrontCanvases();
};

// ─── Gallery / slider observers ───────────────────────────────────────────────
window.addEventListener('resize', updateActiveItem);

window.addEventListener('load', function loadWindowHanle() {
  if (checkIfMobile()) {
    updateMobileSlider(customEnabled, 1);
    updateMobileSlider(customLogo,    0);
  }
  updateActiveItem('load');

  // ── Mobile slider — mirror desktop observer via slick afterChange ─────────
  const mobileSlider = document.getElementById('mobile-product-slider-main');
  if (mobileSlider && window.jQuery) {
    const canvas      = document.querySelector('#jessey-canvas-mobile');
    const canvasFront = document.querySelector('#jessey-canvas-front-mobile');

    jQuery(mobileSlider).on('afterChange', function afterChangeHandle(e, slick, idx) {
      currentSlide = idx;
      canvas?.classList.toggle     ('active-canvas', idx === 1);
      canvasFront?.classList.toggle('active-canvas', idx === 0);
      if (idx === 0) drawFrontCanvases();
    });
  }

  // ── Desktop gallery observer ──────────────────────────────────────────────
  const gallery = document.querySelector('#smallGallery');
  if (!gallery) return;

  const canvas      = document.querySelector('#jessey-canvas');
  const canvasFront = document.querySelector('#jessey-canvas-front');
  let   lastTimeout;

  const observer = new MutationObserver(mutations => {
    for (const { type, attributeName, target } of mutations) {
      if (type !== 'attributes' || attributeName !== 'class') continue;
      const li = target.closest('.slick-slide');
      if (!li) continue;
      clearTimeout(lastTimeout);
      lastTimeout = setTimeout(() => {
        const idx = parseInt(li.getAttribute('data-slick-index'), 10);
        currentSlide = idx;
        canvas?.classList.toggle     ('active-canvas', idx === 1);
        canvasFront?.classList.toggle('active-canvas', idx === 0);
        if (idx === 0) drawFrontCanvases();
      }, 10);
    }
  });

  gallery.querySelectorAll('.slick-slide a').forEach(a =>
    observer.observe(a, { attributes: true, attributeFilter: ['class'] })
  );
});